module.exports = __webpack_public_path__ + "static/media/02  ON INTERNET ALÁMBRICO 80.74835ec0.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/ift/InternetAl/02  ON INTERNET ALÁMBRICO 80.pdf
// module id = 857
// module chunks = 0